import {Injectable} from '@angular/core';
import {CrudService} from '@ngx-ivengi/crud';
import {Note} from './note.model';

@Injectable()
export class NoteService extends CrudService<Note> {
  public entityType = Note;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/maintenance/note/note.service.ts